module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/confirm-dialog/confirm-dialog.component.css
// module id = ./src/app/achelos-iot/modals/confirm-dialog/confirm-dialog.component.css
// module chunks = main